import { ComplianceAppNirvanaDataProvider } from '../dataProvider/ComplianceAppNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class ComplianceAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, ComplianceAppNirvanaDataProvider);
  }
}
